export const content = {
  title: "Publishers",
  subtitle: "Breakdown your media channel investments by publisher to optimize future decisions.",
};

export const noDataContent = {
  title: "Insufficient Data",
  description:
    "Sorry, there is not enough data to show this module. Try selecting a difference business unit or adjusting your date range.",
};
